<template>
  <div class="wrapper">
    <div class="close-btn" @click="close">
      <Icon class="icon" :fill="'#719192'" :width="'20px'" :height="'20px'" :name="'close'"/>
    </div>
    <p class="login-title">Sign Up</p>
    <div class="container">
      <form>
        <input type="text" placeholder="email address" v-model="phone"/><br/>
        <input type="text" placeholder="user name" v-model="uname"/><br/>
        <input class="vcodeInput" type="text" placeholder="code" v-model.trim="vcode"/>
        <p class="verCode" ref="sendbtn" @click="sendCode" :class="{sended: sended}">Send</p><br/>
        <input type="password" placeholder="password" v-model="pwd"/><br/>
        <input type="password" placeholder="confirm password" v-model.trim="cpwd"/><br/>
        <label>country:</label>
        <select class="select" v-model="country">
          <!-- <option disabled selected value="" style="display:none;">--请选择国家--</option> -->
          <option
          v-for="(item, index) in countryList"
          :value="item.country_id" :key="index">
          {{item.name}}
        </option>
      </select>
    </form>
  </div>
  <div class="footer">
    <p class="button" @click.prevent="register">Register</p>
    <a @click="login" class="login">Have an account? Sign In</a>
  </div>
</div>
</template>
<script>
import Icon from '@/components/Reusables/Icon'
import axios from 'axios';
import {Register, Smscode, GetCountry} from '@/api/index.js'
export default {
  name: 'Register',
  components:{
    Icon,
  },
  data() {
    return {
      sended:false,
      phone:null,
      vcode:null,
      pwd:null,
      cpwd:null,
      country:null,
      uname:null,
      countryList:[],
      userCountry:null,
    };
  },
  methods:{
    initData(){
      this.getUserCountry(this.getAllCountry);

      //获取邀请码
      let code = this.$route.query.code;
      if(code){
        this.code = code;
      }
    },
    login(){
      this.$store.commit('setCred', 'login')
    },
    showLogin(){
      this.$emit('showlogin');
    },
    closereg(){
      this.$emit('closereg');
    },
    register(){
      console.log(this.phone, this.pwd, this.cpwd, this.vcode);
      if(!this.phone, !this.pwd, !this.cpwd, !this.vcode){
        window.alert("please fill all the blank form");
        return;
      }
      if(this.pwd != this.cpwd){
        window.alert("your confirm password doesn't match your password")
        return;
      }

      console.log('country id: ' + this.country);
      Register({'email':this.phone,'password':this.pwd,"country_id":this.country,'vcode':this.vcode, 'username' : this.uname}).then(res=>{
        window.alert('register succeed');
        localStorage.setItem('countDown',null);
        localStorage.setItem('countTime',null);
        this.$router.push({path:'/'});
      })
    },
    sendCode(){
      if(this.sended) return false;

      let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if(!reg.test(this.phone)){
        window.alert('please enter a valid email address');
        return false;
      }
      Smscode({'email':this.phone}).then(res => {
        this.sended =  true;
        localStorage.setItem('countDown', null);
        this.sendCountDown();
      });
    },
    sendCountDown(){
      let sendbtn = this.$refs.sendbtn;
      //localStorage.getItem() below is actually doesn't affect anything, time eventually use 60 as its value
      let time = 60;
      let that = this;
      sendbtn.innerHTML = time + 's to resend';
      let myInterval = window.setInterval(function(){
        if(time <= 0){
          that.sended = false;
          // time = 60;
          localStorage.setItem('countDown',null);
          localStorage.setItem('countTime',null);
          sendbtn.innerHTML = 'Send';
          window.clearInterval('myInterval');
          return;
        }
        time--;
        sendbtn.innerHTML = time + 's to resend';
        localStorage.setItem('countDown',time);
        localStorage.setItem('countTime', new Date().getTime());
      },1000)
    },
    getUserCountry(){
      console.log('user country triggered!')
      axios.get('http://api.ipstack.com/check?access_key=341a88b0df9a9704bbc67cf7f39c97f1&fields=country_name').then(response => {
        this.userCountry = response.data.country_name;
        console.log('API success: ' + this.userCountry);

        if(arguments.length > 0){
          arguments[0]()
        }
      }).catch(error =>{
        console.log('error from user country API: ' + error);
        this.userCountry = null;
      })
    },
    getAllCountry(){
      GetCountry({}).then(res => {
        this.countryList = res.data;
        console.log(this.userCountry);
        for(let k in this.countryList){
          if(this.countryList[k].name == this.userCountry){
            this.country = this.countryList[k].country_id;
          }
        }
      })
    },
    close(){
      this.$store.commit('setCred', null)
    },
  },
  created(){
    this.initData();
  },
};
</script>
<style lang="" scoped>
@import './Reusables/cred.css';
.wrapper{
  /* width:100%; */
    width: calc(480px - 60px);
    height: calc(580px - 60px);
    padding: 30px;
    overflow: hidden;
}
.container{
  width: calc(100% - 10px);
  padding-right: 10px;
  height: 320px;
  overflow-y: auto;
}
.container::-webkit-scrollbar{
    background-color: none;
    width: 6px;
}
.container::-webkit-scrollbar-thumb{
    background-color: #485053ad;
    border-radius: 20px;
}
.container::::-webkit-scrollbar-thumb:hover{
    background-color: #485053;
}

input[type="text"],input[type="password"]{
  border: 0;
  background: transparent;
  border-bottom: 4px solid #719192;
  width: 100%;
  font-size: 22px;
  padding-bottom: 10px;
  margin-bottom: 40px;
  color: #719192;
}
input:focus{
  outline: none;
  /* border-color: red; */
}
.login-title{
  font-size: 30px;
  font-weight: bold;
  text-align: right;
  margin-bottom: 50px;
  color: #719192;
  margin-top: 0;
}
.button{
  background: #719192;
  width: 100%;
  text-align: center;
  font-size: 32px;
  line-height: 60px;
  color: #fff;
  border-radius: 10px;
}
.button:hover{
  cursor: pointer;
  opacity: 0.8;
  color:#fff;
}
.closelogin{
  float:right;
  margin:10px 30px 0 0
}
.closelogin:hover{
  cursor: pointer;
}
.forgotpwd,.register{
  font-size: 16px;
  margin:0;
  margin-bottom: 10px;
}
.forgotpwd:hover,.register:hover{
  text-decoration: underline;
  cursor: pointer;
}
.vcodeInput{
  width: 45%!important;
  display: inline-block;
}
.verCode{
  display: inline-block;
  /* background: lavender; */
  margin-left:2%;
  padding:10px;
  border-radius: 10px;
  font-size: 13px;
  color:#fff;
  background: #719192;
  text-align: center;
}
.verCode:hover{
  cursor: pointer;
  opacity: 0.8;
  color:#fff;
}
.sended{
  background: #ABCED2;
}
.sended:hover{
  cursor: auto;
  opacity: 1;
}
.login{
  margin-top:20px;
  text-align: center;
  display: block;
  color:#000;
  text-decoration: none;
}
a{
  color:#719192!important;
}
a:hover{
  color:#719192;
}
.select{
  padding: 5px;
  border-radius: 10px;
  width: 100%;
  /* border-radius: 15px; */
  border: 0;
  margin-bottom: 20px;
  border: 2px solid #719192;
  margin-top: 10px;
}
.select:focus{
  outline: none;
}

label{
  color:#757575;
  font-size: 22px;
  /* margin-bottom: 10px; */
}
@media screen and (max-width: 900px){
  .login-page{
    width: 70%;
    max-width: 450px;
    min-width: 220px;
    padding:30px;
    margin-top: 80px;
  }
  input[type="text"],input[type="password"]{
    width: 90%;
    border-radius: 0;
    border-bottom: 3px solid #859D9F;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Register.vue